import React, { useEffect, useState, useContext, useRef, useCallback, useMemo } from 'react';
import DevicesSelector from './DevicesSelector.jsx';
import MediaElement from '../MediaElement.jsx';
import HardwareSetupCamera from './HardwareSetupCamera.jsx';
import DispatchContext from '../../contexts/DispatchContext';
import StateContext from '../../contexts/StateContext';
import RequestPermissionsButton from './RequestPermissionsButton.jsx';
import ConnectionSpeed from './ConnectionSpeed.jsx';

const HardwareSetup = (props) => {
	const videoRef = useRef();
	const state = useContext(StateContext);
	const { activeAudioOutput } = state;
	const isProducer = state.currentParticipant.role === 'producer';
	const showSetup = (props.hasPermission || isProducer) && !state.error;
	const name = state.currentParticipant?.name;
	const connectionSpeed = state.currentParticipant?.connectionSpeed;
	const videoSettings = useMemo(() => {
		const videoTrack = props.mediaStream?.getVideoTracks()[0];
		if (!videoTrack) return;
		return videoTrack?.getSettings();
	}, [props.mediaStream]);

	useEffect(() => {
		if (!activeAudioOutput?.deviceId) return;
		videoRef.current?.setSinkId(activeAudioOutput.deviceId);
	}, [activeAudioOutput?.deviceId]);

	useEffect(() => {
		if (!props.permissionsInitialyDenied && props.hasPermission && state.currentParticipant.role === 'audience') {
			props.onPermissionsRequest(undefined, 'audience that has permission');
		}
	}, [props.hasPermission, state.currentParticipant.role]);

	if (showSetup) {
		return (
			<div
				// style={{minWidth:380}}
				className={'bg-jetGrey rounded-xl flex flex-col p-4 pb-5 items-stretch '}
			>
				<div className={`flex flex-col ${!state.currentParticipant.hasVideo && 'h-52'}`}>
					<HardwareSetupCamera
						videoRef={videoRef}
						name={name}
						videoSettings={videoSettings}
						mediaStream={props.mediaStream}
						isProducer={isProducer}
						hasVideo={state.currentParticipant.hasVideo}
						hasAudio={state.currentParticipant.hasAudio}
						isInsideGreenRoom={props.isInsideGreenRoom}
					/>
				</div>
				<ConnectionSpeed connectionSpeed={connectionSpeed} />
				<DevicesSelector
					onDeviceChange={props.onDeviceChange}
					disabled={props.disabled}
					mediaStream={props.mediaStream}
					hiddenSelectors={props.hiddenSelectors}
				/>
				{state.currentParticipant.role === 'producer' && !props.hasPermission && (
					<RequestPermissionsButton onPermissionsRequest={props.onPermissionsRequest} />
				)}
			</div>
		);
	} else {
		return <div className="text-ivory text-center">Camera setup</div>;
	}
};
export default HardwareSetup;
